/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_poi_card__review__mediocre = /** @type {(inputs: {}) => string} */ () => {
	return `Mittelmäßig`
};

const en_poi_card__review__mediocre = /** @type {(inputs: {}) => string} */ () => {
	return `Mediocre`
};

const es_poi_card__review__mediocre = /** @type {(inputs: {}) => string} */ () => {
	return `Mediocre`
};

const fr_poi_card__review__mediocre = /** @type {(inputs: {}) => string} */ () => {
	return `Médiocre`
};

const it_poi_card__review__mediocre = /** @type {(inputs: {}) => string} */ () => {
	return `Mediocre`
};

const nl_poi_card__review__mediocre = /** @type {(inputs: {}) => string} */ () => {
	return `Middelmatig`
};

const pt_poi_card__review__mediocre = /** @type {(inputs: {}) => string} */ () => {
	return `Medíocre`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__mediocre = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.poi_card__review__mediocre(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("poi_card__review__mediocre", locale)
	if (locale === "de") return de_poi_card__review__mediocre(inputs)
	if (locale === "en") return en_poi_card__review__mediocre(inputs)
	if (locale === "es") return es_poi_card__review__mediocre(inputs)
	if (locale === "fr") return fr_poi_card__review__mediocre(inputs)
	if (locale === "it") return it_poi_card__review__mediocre(inputs)
	if (locale === "nl") return nl_poi_card__review__mediocre(inputs)
	return pt_poi_card__review__mediocre(inputs)
};